import CTA14 from './CTA14.js'
export default CTA14
